<template>
  <div
    ref="myTree"
    style="padding: 16px"
    :style="{ height: height + (type === 'edit' ? 40 : 0) + 'px' }"
    class="my-tree"
  >
    <div class="my-tree-item" v-for="(item, index) in list" :key="item.id">
      <template v-if="type === 'edit'">
        <el-button
          @click="addRow"
          class="input"
          icon="el-icon-plus"
          :style="{
            left: item.left + 'px',
            top: item.top + 'px',
            width: item.width + 'px',
            height: inputHeight + 'px',
          }"
          v-if="index == list.length - 1"
        ></el-button>
        <div
          v-else
          class="input"
          :style="{
            left: item.left + 'px',
            top: item.top + 'px',
            width: item.width + 'px',
            height: inputHeight + 'px',
          }"
        >
          <el-input
            :disabled="disabled"
            v-model="item.lable1"
            @focus="inputFocus(item)"
            @blur="editRow(item)"
          >
            <template #append>
              <el-icon><Minus @click="delRow(item)" /> </el-icon>
            </template>
          </el-input>
        </div>
      </template>
      <template v-else>
        <div
          class="input view"
          :style="{
            left: item.left + 'px',
            top: item.top + 'px',
            width: item.width + 'px',
            height: inputHeight + 'px',
          }"
        >
          {{ item.lable1 }}
        </div>
      </template>
      <img
        class="icon-arrow"
        style="width: 40px"
        v-if="index != list.length - 1"
        :style="{
          left: item.arrowLeft + 'px',
          top: item.arrowTop + 'px',
          transform: `rotate(${item.arrowRotate}deg)`,
        }"
        src="@/assets/images/arrow.png"
        alt=""
      />
    </div>
    <el-input
      style="position: absolute; z-index: -9999"
      ref="elInput"
    ></el-input>
  </div>
</template>

<script>
/**
 * @description 这个页面用vue3有问题 所以只能直接赋值过来
 */
export default {
  props: {
    type: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      list: [],
      height: 58,
      inputHeight: 26,
      disabled: false,
      currentLabel: "",
    };
  },
  methods: {
    getStyle(list) {
      const clientWidth = this.$refs.myTree
        ? this.$refs.myTree.clientWidth
        : 900;
      const height = this.$refs.elInput.$el.clientHeight || 26;
      this.inputHeight = height;
      list.forEach((item, index) => {
        index = index + 1;
        const padding = 0;
        const arrowWidth = 40;
        const arrowheight = 7.7;
        const width = (clientWidth - 16 * 2 - arrowWidth * 4) / 5;
        const row = Math.ceil(index / 5);
        this.height = (arrowWidth + height) * (row - 1) + 16 * 2 + height;
        const col = index % 5;
        // 偶数列
        item.width = width;
        if (row % 2 === 0) {
          item.left =
            col === 0 ? padding : padding + (width + arrowWidth) * (5 - col);
          item.top =
            row === 1 ? padding : padding + (height + arrowWidth) * (row - 1);
          item.arrowLeft =
            col === 1
              ? padding + width + (width + arrowWidth) * 3
              : col === 0
              ? padding + width / 2 - arrowWidth / 2
              : padding + (width + arrowWidth) * (4 - col) + width;
          item.arrowTop =
            col === 0
              ? height +
                arrowWidth / 2 +
                (arrowWidth + height) * (Math.ceil(index / 5) - 1) -
                arrowheight / 2
              : row === 1
              ? padding + height / 2 - arrowheight / 2
              : padding +
                (height + arrowWidth) * (row - 1) +
                height / 2 -
                arrowheight / 2;
          item.arrowRotate = col === 0 ? 90 : 180;
        } else {
          item.left =
            col === 1
              ? padding
              : col === 0
              ? padding + (width + arrowWidth) * 4
              : padding + (width + arrowWidth) * (col - 1);
          item.top =
            row === 1 ? padding : padding + (height + arrowWidth) * (row - 1);
          item.arrowLeft =
            col === 1
              ? padding + width
              : col === 0
              ? padding + (width + arrowWidth) * 4 + width / 2 - arrowWidth / 2
              : padding + (width + arrowWidth) * (col - 1) + width;
          item.arrowTop =
            col === 0
              ? padding +
                height +
                arrowWidth / 2 +
                (arrowWidth + height) * (Math.floor(index / 5) - 1) -
                arrowheight / 2
              : row === 1
              ? padding + height / 2 - arrowheight / 2
              : padding +
                (height + arrowWidth) * (row - 1) +
                height / 2 -
                arrowheight / 2;
          item.arrowRotate = col === 0 ? 90 : 0;
        }
      });
      this.list = list;
    },
    addRow() {
      this.disabled = true;
      this.$emit("addRow", this.list[this.list.length - 2]);
    },
    editRow(e) {
      if (this.currentLabel === e.lable1) {
        return false;
      }
      this.disabled = true;
      this.$emit("editRow", e);
    },
    delRow(e) {
      this.disabled = true;
      this.$emit("delRow", e);
    },
    inputFocus(e) {
      this.currentLabel = e.lable1;
    },
    show(data) {
      this.disabled = false;
      this.getStyle(
        this.type === "edit"
          ? [...data, { lable1: "新增", id: "null" }]
          : [...data]
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.my-tree {
  position: relative;
  width: 100%;
  height: 500px;
  box-sizing: border-box;
  .my-tree-item {
    position: absolute;
    width: 20%;
  }
  .input {
    position: absolute;
    width: 100%;
  }
}
.icon-arrow {
  position: absolute;
  transform-origin: (50% 50%);
}
.view {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e2edff;
  border-radius: 4px;
}
</style>
